import { useState } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { parseDoubleEncodedJson } from '../../utils/apiHelpers';

interface UpdateContactPayload {
    contact_id: string | number;
    NAME?: string;
    LASTNAME?: string;
    FIRSTNAME?: string;
    JOB?: string;
    CIVILITY?: string;
    EMAIL?: string;
    PHONE?: string;
    DIALING_CODE?: string;
    TRAP_LEVEL?: string;
}

interface UpdateContactResponse {
    success: boolean;
    contact?: any;
    message?: string;
}

const useUpdateContact = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const updateContact = async (payload: UpdateContactPayload): Promise<UpdateContactResponse | null> => {
        if (!isReady || !workspaceId) {
            setError('Workspace not ready');
            return null;
        }

        setIsLoading(true);
        setError('');
        try {
            const result = await authFetch('/updateEntContact', {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            return parseDoubleEncodedJson(result) || { success: true };
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : 'Unknown error while updating the contact.';
            console.error('[useUpdateContact] failed:', { workspaceId, payload, message });
            setError(message);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { updateContact, isLoading, error };
};

export default useUpdateContact;
